<template>
    
    <v-container style=" margin-top: 80px;">
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title class="pa-5 pb-3 primary">
                        <v-icon class="pr-3" style="color: white;">mdi-chart-bar</v-icon>
                        <p style="color: white;">Mis Pendientes</p><span class="grey--text font-weight-regular subtitle-2 pt-1"></span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            
                            <v-col cols=12 md="2">
                                <!--<div class="selc">
        <v-select :items="items"
                  label="Ver"
                  @change="Cargar()"
                  v-model="filtro"
                  append-outer-icon="mdi-filter-outline"
                  solo></v-select>
    </div>-->
                                <v-menu bottom
                                        offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="ma-2"
                                               v-bind="attrs"
                                               color="primary"
                                               v-on="on">
                                            <v-icon left>
                                                mdi-filter-outline
                                            </v-icon>
                                            Ver
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item v-for="(item, i) in items"
                                                     :key="i"
                                                     @click="Cargar(item.title)">
                                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>

                            </v-col>

                        </v-row>
                        <v-row>
                            <v-col cols=12 md="5" style="float: none; margin: 0 auto; ">
                                <vs-list>
                                    <!--<vs-list-header title="Documentación Adjuntada" color="warning"></vs-list-header>-->
                                    <!--<vs-list-header title="Documentación por Adjuntar" color="primary"></vs-list-header>-->
                                    <vs-list-item title="Envio de link" subtitle="">
                                        <v-btn rounded color="primary" @click="Adjuntar(poradjuntar)" dark>{{poradjuntar}}</v-btn>
                                    </vs-list-item>
                                    <vs-list-item title="Sin Primer Contacto" subtitle="">
                                        <v-btn rounded color="success" @click="Adjunto(primercontacto.sinres)" dark>{{primercontacto.sinres}}</v-btn>
                                    </vs-list-item>
                                    <vs-list-item title="Primer Contacto con Respuesta No" subtitle="">
                                        <v-btn rounded color="success" @click="Contacto(primercontacto.resno)" dark>{{primercontacto.resno}}</v-btn>
                                    </vs-list-item>
                                </vs-list>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import servicio from '@/services/Operacion/MisPendientes.service.js';

    export default {
        data: () => ({
            datos: [],
            existe: false,
            docto: false,
            adjuntos: [],
            items: [
                {
                    title: 'Todos',
                },
                {
                    title: 'Usuario',
                },
            ],
            filtro: 'Todos',
            adjuntos: 0,
            poradjuntar: 0,
            primercontacto: '',
            colors: 'primary',
        }),
        props:['inifil'],
        computed: {
            ...mapState(['domain', 'informationPage']),
        },
        methods: {
            Cargar(filtra) {
                this.filtro = filtra;
                //console.log(this.filtro);
                let formdata = new FormData();
                formdata.append("tipo", this.filtro);
                this.TotalesAdjuntados(formdata);
                this.TotalesPendientes(formdata);
            },
            async TotalesPendientes(data) {
                await servicio.TotalesPendientes(this, data).then(data => {
                    this.datos = data;
                    this.poradjuntar = data[0].doctos;
                    this.existe = true;
                });
            },
            async TotalesAdjuntados(data) {
                await servicio.TotalesPrimerContacto(this, data).then(data => {
                    console.log(data[0]);
                    this.primercontacto = data[0];
                    this.docto = true;
                });
            },
            Adjuntar(total) {
                //console.log(total);
                if (total > 0)
                    this.$router.push({ name: `doctoAdjuntar`, params: { filtro: this.filtro } });
                else {
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Informativo',
                        text: 'No hay registros que mostrar',
                        showConfirmButton: false,
                        timer: 2000
                    });
                }
            },
            Adjunto(total) {
                //console.log(total);
                if (total > 0)
                    this.$router.push({ name: `doctoAdjunto`, params: { filtro: this.filtro } });
                else {
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Informativo',
                        text: 'No hay registros que mostrar',
                        showConfirmButton: false,
                        timer: 2000
                    });
                }
            },
            Contacto(total) {
                if (total > 0)
                    this.$router.push({ name: `ContactoRespuesta`, params: { filtro: this.filtro } });
                else {
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Informativo',
                        text: 'No hay registros que mostrar',
                        showConfirmButton: false,
                        timer: 2000
                    });
                }
            },
        },
        mounted() {
            if (this.inifil != undefined) {
                this.filtro = this.inifil;
                this.Cargar(this.filtro);
            }
            else
                this.Cargar('Todos');
        },
        created() {
            //this.Cargar();
            //this.TotalesPendientes();
            //this.TotalesAdjuntados();
        },
    }
</script>
<style>
    .selc .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
        background: #2979FF !important;
    }
    .selc .theme--light.v-select .v-select__selections {
        color: #f9fafb !important;
    }
</style>